import { ReactNode } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ErrorAlertProps {
  children: ReactNode;
  onClose?: () => void;
  className?: string;
}

export function ErrorAlert({ children, onClose, className }: ErrorAlertProps) {
  return (
    <div
      className={cn(
        'rounded-[6px] border border-[#ea2261]/20 bg-[#ea2261]/5 text-[#ea2261] px-4 py-3 text-sm flex items-start gap-2',
        className
      )}
    >
      <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="flex-1">{children}</div>
      {onClose && (
        <button onClick={onClose} className="shrink-0 hover:opacity-70">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
